"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var basicSingleLink = {
    id: '',
    title: '',
    link: '',
    isDisplay: true,
    isInChildren: false,
    isTargetBlank: false,
    children: [],
};
exports.default = basicSingleLink;
